/* istanbul ignore file */

import { NumberFormatOptions } from '../enums/number-format-options.enum';

export const NUMBER_FORMAT_CONSTANTS = {
    numberFormatOptions: [
        { text: 'Number (default)', value: NumberFormatOptions.Number },
        { text: 'Percent (%)', value: NumberFormatOptions.Percent },
        { text: 'US Dollar ($)', value: NumberFormatOptions.USDollar },
        { text: 'Duration (days)', value: NumberFormatOptions.Duration },
        { text: 'Duration (hours)', value: NumberFormatOptions.Hours }
    ],

    decimalPlacesOptions: [
        { text: 'No formatting applied (default)', value: -1 },
        { text: '0 decimals (100)', value: 0 },
        { text: '1 decimal (100.0)', value: 1 },
        { text: '2 decimals (100.00)', value: 2 },
    ],

    usDollarPrefix: '$',
    percentSuffix: ' %',
    durationSuffixPlural: ' days',
    durationSuffixSingular: ' day',
    hoursSuffixPlural: ' hours',
    hoursSuffixSingular: ' hour',
    defaultDecimalPlace: -1
};
